import { E as s, D as r, F as o } from "./export-cdcbfb2b.js";
var n = r, l = o, c = s, i = c("match"), f = function(a) {
  var e;
  return n(a) && ((e = a[i]) !== void 0 ? !!e : l(a) === "RegExp");
};
export {
  f as i
};
